import { compareNumbers } from 'utils/functions';

const AllEpicNames = [
  'CS.D.AUDCAD.CZD.IP',
  'CS.D.AUDCHF.CZD.IP',
  'CS.D.AUDCNH.CFD.IP',
  'CS.D.AUDCNH.CZD.IP',
  'CS.D.AUDEUR.CZD.IP',
  'CS.D.AUDGBP.CZD.IP',
  'CS.D.AUDNZD.CZD.IP',
  'CS.D.AUDSGD.CZD.IP',
  'CS.D.AUDUSD.CFD.IP',
  'CS.D.AUDUSD.CZD.IP',
  'CS.D.CADCHF.CFD.IP',
  'CS.D.CADCHF.CZD.IP',
  'CS.D.CADCNH.CZD.IP',
  'CS.D.CADJPY.CFD.IP',
  'CS.D.CADJPY.CZD.IP',
  'CS.D.CADNOK.CZD.IP',
  'CS.D.CHFHUF.CZD.IP',
  'CS.D.CHFJPY.CFD.IP',
  'CS.D.CHFJPY.CZD.IP',
  'CS.D.CHFNOK.CZD.IP',
  'CS.D.CNHJPY.CFD.IP',
  'CS.D.CNHJPY.CZD.IP',
  'CS.D.EURAUD.CZD.IP',
  'CS.D.EURCAD.CFD.IP',
  'CS.D.EURCAD.CZD.IP',
  'CS.D.EURCHF.CFD.IP',
  'CS.D.EURCHF.CZD.IP',
  'CS.D.EURCNH.CFD.IP',
  'CS.D.EURCNH.CZD.IP',
  'CS.D.EURCZK.CZD.IP',
  'CS.D.EURDKK.CZD.IP',
  'CS.D.EURGBP.CFD.IP',
  'CS.D.EURGBP.CZD.IP',
  'CS.D.EURHUF.CZD.IP',
  'CS.D.EURJPY.CFD.IP',
  'CS.D.EURJPY.CZD.IP',
  'CS.D.EURMXN.CZD.IP',
  'CS.D.EURNZD.CZD.IP',
  'CS.D.EURPLN.CZD.IP',
  'CS.D.EURSEK.CZD.IP',
  'CS.D.EURSGD.CFD.IP',
  'CS.D.EURSGD.CZD.IP',
  'CS.D.EURTRY.CZD.IP',
  'CS.D.EURUSD.CFD.IP',
  'CS.D.EURUSD.CZD.IP',
  'CS.D.EURUSD.TODAY.IP',
  'CS.D.EURZAR.CFD.IP',
  'CS.D.EURZAR.CZD.IP',
  'CS.D.GBPAUD.CZD.IP',
  'CS.D.GBPCAD.CFD.IP',
  'CS.D.GBPCAD.CZD.IP',
  'CS.D.GBPCHF.CFD.IP',
  'CS.D.GBPCHF.CZD.IP',
  'CS.D.GBPCNH.CZD.IP',
  'CS.D.GBPCZK.CZD.IP',
  'CS.D.GBPDKK.CZD.IP',
  'CS.D.GBPEUR.CFD.IP',
  'CS.D.GBPEUR.CZD.IP',
  'CS.D.GBPINR.CFD.IP',
  'CS.D.GBPJPY.CFD.IP',
  'CS.D.GBPJPY.CZD.IP',
  'CS.D.GBPMXN.CZD.IP',
  'CS.D.GBPNOK.CZD.IP',
  'CS.D.GBPNZD.CZD.IP',
  'CS.D.GBPPLN.CZD.IP',
  'CS.D.GBPSEK.CZD.IP',
  'CS.D.GBPSGD.CFD.IP',
  'CS.D.GBPSGD.CZD.IP',
  'CS.D.GBPUSD.CFD.IP',
  'CS.D.GBPUSD.CZD.IP',
  'CS.D.GBPZAR.CFD.IP',
  'CS.D.GBPZAR.CZD.IP',
  'CS.D.NZDCAD.CZD.IP',
  'CS.D.NZDCHF.CZD.IP',
  'CS.D.NZDEUR.CZD.IP',
  'CS.D.NZDGBP.CZD.IP',
  'CS.D.NZDJPY.CZD.IP',
  'CS.D.NZDUSD.CZD.IP',
  'CS.D.SGDJPY.CFD.IP',
  'CS.D.SGDJPY.CZD.IP',
  'CS.D.TRYJPY.CZD.IP',
  'CS.D.USDBRL.CFD.IP',
  'CS.D.USDCAD.CFD.IP',
  'CS.D.USDCAD.CZD.IP',
  'CS.D.USDCHF.CFD.IP',
  'CS.D.USDCHF.CZD.IP',
  'CS.D.USDCNH.CFD.IP',
  'CS.D.USDCNH.CZD.IP',
  'CS.D.USDDKK.CZD.IP',
  'CS.D.USDHUF.CZD.IP',
  'CS.D.USDIDR.CFD.IP',
  'CS.D.USDILS.CZD.IP',
  'CS.D.USDINR.CFD.IP',
  'CS.D.USDJPY.CFD.IP',
  'CS.D.USDJPY.CZD.IP',
  'CS.D.USDKRW.CFD.IP',
  'CS.D.USDMXN.CZD.IP',
  'CS.D.USDNOK.CZD.IP',
  'CS.D.USDPHP.CFD.IP',
  'CS.D.USDPLN.CZD.IP',
  'CS.D.USDSEK.CZD.IP',
  'CS.D.USDSGD.CFD.IP',
  'CS.D.USDSGD.CZD.IP',
  'CS.D.USDTRY.CZD.IP',
  'CS.D.USDTWD.CFD.IP',
  'CS.D.USDZAR.CFD.IP',
  'CS.D.USDZAR.CZD.IP',
  'CS.D.sp_EURRUB.CFD.IP',
] as const;

const AllEpicFields = ['BID', 'OFR', 'CPT', 'CPC', 'HIG', 'LOW', 'UTM', 'SPRD', 'SWAP_5_SHORT', 'SWAP_5_LONG'] as const;

export type EpicName = (typeof AllEpicNames)[number];

export type EpicField = (typeof AllEpicFields)[number];

type Epic = {
  name: EpicName;
  fields: Array<EpicField>;
};

export const UPDATE_TYPES = {
  SNAPSHOT: 'SNAPSHOT',
  UPDATE: 'UPDATE',
} as const;

export type UpdateType = (typeof UPDATE_TYPES)[keyof typeof UPDATE_TYPES];

type MarketDataEntry<T = string | number> = {
  value: T;
  change?: number;
};

export type MarketData = {
  [key in EpicField]: MarketDataEntry;
} & {
  UPDATE_TYPE: MarketDataEntry<UpdateType>;
};

export type EpicData = {
  y: number;
  MARKET: Record<string, MarketData | undefined>;
};

//The adapter set determines which data we access
//InVisionProvider seems to be the only adapter set available on upp.ig.com
const ADAPTER_SET = 'InVisionProvider';

//This is used in the javascript for the client, set here to match ig.com/us/forex
const CONTAINER = 'lsc';

//This is a constant defined in the real Lightstreamer library
//This is the value used on ig.com/us/forex, it is different than the 8.0.8 library
const com_lightstreamer_internal_Constants_LS_CID = 'pcYgxn8m8 feOojyA1T681f3g2.pz479mDv';

/**
 * Manages a connection to a not-really-Lightstreamer server
 * to fetch live pricing data.
 *
 * The only known server in the wild is upp.ig.com
 */
class CaxyLightstream {
  private server: string;
  private websocketServer: string | null = null;
  private subscriptions: { [key: number]: Epic } = {};
  private nextId = 1;

  private sessionId: string | null = null;
  private websocket: WebSocket | null = null;
  private phase: number;

  private data: EpicData = { y: 0, MARKET: {} };

  private callbacks: Array<CallableFunction> = [];

  constructor(host: string, dataCallback?: CallableFunction) {
    this.server = host;
    this.phase = Math.round(Math.random() * 9999); //TODO: figure out what this is
    dataCallback && this.callbacks.push(dataCallback);
  }

  public getData() {
    return this.data;
  }

  public async subscribe(epics: Epic | Array<Epic>) {
    if (!this.websocket) {
      await this.connectWebsocket();
      if (!this.websocket) {
        throw new Error("couldn't connect to web socket");
      }
    }

    (Array.isArray(epics) ? epics : [epics]).forEach((epic) => {
      const LS_id = `V2-F-${epic.fields.join('%2c')}%3ASCALED%7C${epic.name}%7C1`;
      const LS_schema = epic.fields.join('%20');

      this.subscriptions[this.nextId] = epic;

      this.websocket?.send(
        `control\r\nLS_mode=MERGE&LS_id=${LS_id}&LS_schema=${LS_schema}&LS_snapshot=true&LS_requested_max_frequency=1&LS_table=${this.nextId}&LS_req_phase=${this.nextId + 1}&LS_win_phase=1&LS_op=add&LS_session=${this.sessionId}&`
      );
      this.nextId++;
    });
  }

  public async subscribeList(names: string[]) {
    const epics = names.map(
      (name) =>
        ({
          name: name as EpicName,
          fields: AllEpicFields.map((v) => v),
        }) as Epic
    );

    await this.subscribe(epics);
  }

  public async subscribeAll() {
    const epics = AllEpicNames.map(
      (name) =>
        ({
          name: name as EpicName,
          fields: AllEpicFields.map((v) => v),
        }) as Epic
    );

    await this.subscribe(epics);
  }

  public registerCallback(callback: CallableFunction) {
    this.callbacks.push(callback);
  }

  /**
   * Establishes the real-time websocket connection with hte server
   */
  public async connectWebsocket() {
    if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
      return;
    }

    if (!this.websocketServer) {
      await this.initialConnect();
      if (!this.websocketServer) {
        throw new Error('failed to get session & host info for websocket');
      }
    }

    const websocket = new WebSocket(`wss://${this.websocketServer}/lightstreamer`, 'js.lightstreamer.com');

    await new Promise((resolve, reject) => {
      if (!websocket) {
        reject('no websocket');
      }
      websocket?.addEventListener('open', (ev) => {
        resolve(ev);
      });
    });

    websocket.addEventListener('error', (ev) => console.log('websocket error', ev));
    websocket.addEventListener('close', (ev) => {
      console.log('websocket closed', ev);
      this.websocket = null;
    });
    websocket.addEventListener('message', (message) => {
      this.processMessage(message);
    });

    websocket.send(
      `bind_session\r\nLS_session=${this.sessionId}&LS_phase=${this.phase}&LS_cause=loop1&LS_container=${CONTAINER}&`
    );

    this.websocket = websocket;
  }

  /**
   * Connects to a standard HTTPS endpoint to set up a session and be assigned a
   * particular web socket server.
   *
   * Calling this is optional, calling connectWebsocket() will set up the session
   * if it has not already been established.
   */
  public async initialConnect(): Promise<boolean> {
    if (typeof window === 'undefined' || typeof fetch === 'undefined') {
      return false;
    }

    const body = {
      LS_phase: this.phase.toString(),
      LS_op2: 'create',
      LS_cause: 'new.api',
      LS_polling: 'true',
      LS_polling_millis: '0',
      LS_idle_millis: '0',
      LS_cid: com_lightstreamer_internal_Constants_LS_CID,
      LS_adapter_set: ADAPTER_SET,
      LS_container: CONTAINER,
    };

    const response = await fetch(`https://${this.server}/lightstreamer/create_session.js`, {
      method: 'POST',
      body: Object.entries(body)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&'),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    const data = await response.text();

    // the data is actually a block of javascript that must be eval()ed by something
    // when using the normal client.
    // we're not going to do that - we're just going to pull out the session ID
    // and the new websocket host
    const matches = data.match(/start\('([A-Za-z0-9]*)', '(upp[a-z0-9]*.ig.com)'/);

    if (matches?.length === 3) {
      this.sessionId = matches[1];
      this.websocketServer = matches[2];
      this.phase += 2; //Still don't know what this does

      console.log(`initialConnect - found session id ${this.sessionId} and websocket host ${this.websocketServer}`);
      return true;
    }

    return false;
  }

  /**
   * Terminates the web socket session
   */
  public disconnect() {
    this.websocket?.close();
    this.websocket = null;
  }

  private processMessage(message: MessageEvent) {
    message.data
      .trim()
      .split(';')
      .filter((s: string) => s !== '')
      .forEach((stmt: string) => {
        const trimmed = stmt.trim();
        switch (trimmed.charAt(0)) {
          case 'd':
            //standard partial data update for a subscription
            this.processD(trimmed, UPDATE_TYPES.UPDATE);
            break;
          case 'y':
            //this appears to be elapsed seconds since connection
            //not sure what it is actually used for
            this.data.y = Number(trimmed.substring(2, stmt.length - 1));
            break;
          case 'z':
            // snapshot data
            this.processD(trimmed, UPDATE_TYPES.SNAPSHOT);
            break;
          default:
          //Thse were seen in the production site, but aren't being returned here:
          //c - unknown
        }
      });

    this.callbacks.forEach((callback) => callback(this.data));
  }

  //data update, only fields that changed, eg
  // d(40,1,'0.60404',1,'-0.00023',1);
  // d(1,1,'1.09248','1.09285',2);
  // d(1,1,2,'0.00004',1);
  // where the first parameter is the subscription id, second seems to always be 1
  // then the data, followed by a 1 or higher at the end if fields are skipped
  private processD(stmt: string, type: UpdateType): void {
    const parts = stmt.substring(2, stmt.length - 1).split(',');
    const sub = this.subscriptions[Number(parts[0])];

    if (!this.data.MARKET[sub.name]) {
      this.data.MARKET[sub.name] = <MarketData>{};
    }

    this.data.MARKET[sub.name]!.UPDATE_TYPE = {
      value: type,
    };
    let idx = 0;
    for (let part = 2; part < parts.length; part++) {
      //it looks like unquoted numbers indicate skips, while quoted numbers are actual values
      if ("'" === parts[part].charAt(0)) {
        const field = sub.fields[idx];
        const value = parts[part].replaceAll("'", '');
        const parsedVal = isNaN(Number(value)) ? value : Number(value);
        const oldVal = Number(this.data.MARKET[sub.name]?.[field]?.value ?? 0);

        //For some reason we're getting two events, one with the actual change, and a duplicate
        //a moment later. If we actually process both, we get flickering on the table
        const change =
          parsedVal === oldVal && this.data.MARKET[sub.name]?.[field]?.change
            ? (this.data.MARKET[sub.name]![field]?.change ?? 0)
            : compareNumbers(oldVal, Number(parsedVal));

        this.data.MARKET[sub.name]![field] = {
          value: parsedVal,
          change: change,
        };
        idx++;
      } else {
        idx += Number(parts[part]);
      }
    }
  }
}

export default CaxyLightstream;
